module.exports = __webpack_public_path__ + "img/DannHaltApfel.54104242.jpg";